import React from 'react';
import { Icon, Table, Loader, Button, Popup } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema predmeta.</p>;
export default class Equivalence extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isConnected: false,
            loader: true,
            courseEquivalence: [],
        };
        this.ShowComponentByKey = this.ShowComponentByKey.bind(this);
        this.closeForm = this.closeForm.bind(this);
        this.connectCandidateWithStudent = this.connectCandidateWithStudent.bind(this);
        this.getCourseEquivalence = this.getCourseEquivalence.bind(this);
        this.cancelCandidate = this.cancelCandidate.bind(this);
        this.deleteCourseEquivalence = this.deleteCourseEquivalence.bind(this);
    }
    componentDidMount() {
        // this.updateIsConnected()
        this.getCourseEquivalence();
        let element = document.querySelectorAll('#myTab:nth-child(1)');

        element[0].childNodes[1].classList.remove('segment');
    }
    connectCandidateWithStudent(studentId) {
        let candidateId = localStorage.getItem('candidateId');
        let obj = studentId;
        axios.post(`/equivalence/${candidateId}/connect`, obj).then(response => {
            localStorage.setItem('candidateEquivalenceStatus', 'MERGED');// if it changes on backend, change here too
            this.setState({ candidateEquivalenceStatus: localStorage.getItem('candidateEquivalenceStatus') });
            this.closeForm();
        }).catch(() => {
            toast('Povezivanje nije uspjelo!');
        });
    }


    ShowComponentByKey(key) {
        if (key === 'add') {
            this.setState({
                showAddCourse: true,
                showConnectStudent: false
            });
        } else if (key === 'connect') {
            this.setState({
                showAddCourse: false,
                showConnectStudent: true,
            });
        }
    }

    closeForm() {
        this.setState({
            showAddCourse: false,
            showConnectStudent: false,

        });
    }
    getCourseEquivalence() {
        let candidateId = localStorage.getItem('candidateId');
        axios.get(`/equivalence/${candidateId}/courses`).then(res => {
            let courseEquivalence = res.data.map(el => ({
                courseId: el.courseId,
                sourceCourseName: el.sourceCourseName,
                targetCourseName: el.targetCourseName,
                studyProgramSemester: el.studyProgramSemester,
                ects: el.ects,
                mark: el.mark,
                status: el.status,
            }));
            this.setState({
                courseEquivalence, loader: false
            });
        }).catch(err => {
            this.setState({
                loader: false
            });
            toast('Trenutno nije moguće dobaviti izvještaj!');
        });
        return this.state.courseEquivalence;
    }

    deleteCourseEquivalence(courseEquivalenceId) {
        let candidateId = localStorage.getItem('candidateId');
        this.setState({ currentCourseId: courseEquivalenceId, deleting: true });
        axios.delete(`/equivalence/${candidateId}/courses`, { data: courseEquivalenceId }).then(res => {
            this.setState({ currentCourseId: null, deleting: false });
            this.getCourseEquivalence();
            toast('Uspješno ste izbrisali predmet!');
        }).catch(err => {
            this.setState({ currentCourseId: null, deleting: false });
            toast('Došlo je do greške, predmet nije obrisan!');
        });
    }

    cancelCandidate() {
        this.setState({ disableButton: true });
        let candidateId = localStorage.getItem('candidateId');
        axios.post(`/equivalence/${candidateId}/refused-to-enroll`, {}).then(res => {
            localStorage.setItem('candidateEquivalenceStatus', 'REFUSED_TO_ENROLL');// if it changes on backend, change here too
            this.setState({ candidateEquivalenceStatus: localStorage.getItem('candidateEquivalenceStatus') });
        });
    }


    render() {
        return (

            <div>
                {this.state.loader ? <div ><Loader active inline="centered" /></div> : this.state.courseEquivalence.length ?
                    <div>
                        <Table celled selectable compact >
                            <Table.Header>
                                <Table.Row >
                                    <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                    <Table.HeaderCell>Naziv predmeta</Table.HeaderCell>
                                    <Table.HeaderCell width={1}>ECTS</Table.HeaderCell>
                                    <Table.HeaderCell>Priznat kao</Table.HeaderCell>
                                    <Table.HeaderCell width="2">Priznat u semestru</Table.HeaderCell>
                                    <Table.HeaderCell width="2">Ocjena</Table.HeaderCell>
                                    <Table.HeaderCell width="2">Status</Table.HeaderCell>
                                    { localStorage.getItem('showAddButton') !== 'no' && <Table.HeaderCell width="2"></Table.HeaderCell>}

                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.state.courseEquivalence.map((el, index) =>
                                    (<Table.Row
                                        key={index}
                                        onClick={(e) => {
                                            console.log(e);
                                            this.setState({ showCandidateInfo: true });// treba da redirecta na detalji o kandidatima
                                        }}
                                    >
                                        <Table.Cell verticalAlign="middle" >
                                            {index + 1}.
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.sourceCourseName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.ects}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.targetCourseName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width="2">
                                            {el.studyProgramSemester}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width="2">
                                            {el.mark}
                                        </Table.Cell>
                                        <Table.Cell width="3" verticalAlign="middle" warning={el.status === 'THIRD' || el.status === 'HALF'} positive={el.status === 'FULL'} negative={el.status === 'REJECTED'}>

                                            {el.status === 'THIRD' ? <div style={{ float: 'right' }}><Icon name="exclamation" /></div> : el.status === 'FULL' ? <div style={{ float: 'right' }}><Icon name="checkmark" /></div> : el.status === 'HALF' ? <div style={{ float: 'right' }}><Icon name="exclamation" /></div> : <div style={{ float: 'right' }}><Icon name="close" /></div>}
                                            {el.status === 'THIRD' ? 'priznata trećina' : el.status === 'FULL' ? 'priznat' : el.status === 'HALF' ? 'priznata polovina' : 'odbijeno'}
                                        </Table.Cell>
                                        {localStorage.getItem('showAddButton') !== 'no' && <Table.Cell verticalAlign="middle" width="2" textAlign="center">
                                            <Popup
                                                content="Brisanje"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        disabled={this.state.deleting && this.state.currentCandidateId !== el.candidateId}
                                                        compact
                                                        basic="true"
                                                        circular
                                                        icon="trash alternate"
                                                        size="small"
                                                        color="red"
                                                        onClick={() => this.deleteCourseEquivalence(el.courseId)}
                                                    />}
                                            />
                                        </Table.Cell>}

                                    </Table.Row>))}
                            </Table.Body>

                        </Table>
                    </div>

                    : <NoDataMessage />
                }


                <ToastContainer hideProgressBar />

            </div>

        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CandidatesDetails/Equivalence/Equivalence.js